<template>
  <div class="chart-test">
    <h3>Graph Results</h3>
    <canvas id="chart-canvas" width="500" height="500" ref="chartref"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';
//import { sampleBarConfig } from './chart-configurations.js'

export default {
  data() {
    return {
      chartObj: null,
      chartConfig: {
        type: 'bar',
        data: {
          labels: ['1-2', '3-4', '4-5', '6-7', '7-8', '9+'],
          datasets: [{
            label: '# of Responses',
            data: [],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(255, 159, 64, 0.2)'
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
              'rgba(153, 102, 255, 1)',
              'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
          // See https://stackoverflow.com/questions/38512001/charts-js-graph-not-scaling-to-canvas-size
          responsive: false,
          //maintainAspectRatio: false
        }
      },
      labels: [],
      values: []
    }
  },

  props: {
    allResponses: {
      type: Array
    },
    qType: {
      type: String
    },
    qIndex: {
      type: Number
    },
    options: {
      type: Array
    },

    chartData: {
      type: Array
    }
  },
  methods: {
    setChartData() {
      this.chartConfig.data.datasets[0].data = this.chartData;
    },

    computeAvg(qType, qI) { //Gets a question and its type, calculates aggregate
    if (this.allResponses.length == 0 || qType == "linear-scale" || qType == "text-answer") {
      return "No aggregate";
    }
    this.labels = [];
    this.values = [];

    for (let c = 0; c < this.options.length; c++) {
      this.labels.push(this.options[c]);
      this.values.push(0);
    }
    
    for (let i = 0; i < this.allResponses.length; i++) {
        if (this.allResponses == null || this.allResponses[i] == null || this.allResponses[i].responses == null) {
          continue;
        }
        var currResponse = this.allResponses[i].responses[qI]; //Now we have a user's response object to the given question

        if (qType == "multi-select") {
          for (let x = 0; x < currResponse.value.length; x++) {
            //var tempInd = this.labels.indexOf(currResponse.value[x]);
            this.values[currResponse.value[x]] += 1;
          }
        }

        else {
          //var ind = this.labels.indexOf(currResponse.value);
          this.values[currResponse.value] += 1;
        }
      }


    this.chartConfig.data.labels = this.labels;
      this.chartData = this.values;
      
      //this.setChartData();
    }

  },
  mounted() {
    this.setChartData();
    this.chartObj = new Chart(this.$refs.chartref, this.chartConfig);

    
    this.computeAvg(this.qType, this.qIndex);

    this.chartConfig.data.labels = this.labels;
      this.chartData = this.values;
      this.setChartData();
      this.chartObj = new Chart(this.$refs.chartref, this.chartConfig);
      console.log(this.chartData);
    
  },
  // beforeDestroy() {
  //   // This necessary if canvas is reused for a new chart
  //   this.chartObj.destroy();
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/survey-reporting/BarChart.vue